import { Trade, currencyEquals } from '@monadex/sdk'

/**
 * Returns true if the trade requires a confirmation of details before we can submit it
 * @param tradeA trade A
 * @param tradeB trade B
 */
export function tradeMeaningfullyDiffers(tradeA: Trade, tradeB: Trade): boolean {
  return (
    tradeA.tradeType !== tradeB.tradeType ||
    !currencyEquals(tradeA.inputAmount.currency, tradeB.inputAmount.currency) ||
    !tradeA.inputAmount.equalTo(tradeB.inputAmount) ||
    !currencyEquals(
      tradeA.outputAmount.currency,
      tradeB.outputAmount.currency
    ) ||
    !tradeA.outputAmount.equalTo(tradeB.outputAmount)
  )
}

/**
 * Converts a percentage to an amount based on the formatted amount
 * @param percentage percentage to convert
 * @param formattedAmount the base amount as a string
 * @returns the calculated amount as a string with 3 decimal places
 */
export function convertPercentageToAmount(
  percentage: number,
  formattedAmount?: string
): string | undefined {
  if (formattedAmount !== undefined) {
    const amount = parseFloat(formattedAmount) * (percentage / 100)
    return amount.toFixed(3)
  }
  return undefined
}

/**
 * Calculates the remaining amount after deducting a percentage
 * @param percentage percentage to deduct
 * @param formattedAmount the base amount as a string
 * @returns the remaining amount as a string with 3 decimal places
 */
export function calculateRemainingAmount(
  percentage: number,
  formattedAmount?: string
): string | undefined {
  if (formattedAmount !== undefined) {
    const totalAmount = parseFloat(formattedAmount)
    const deductedAmount = totalAmount * (percentage / 100)
    const remainingAmount = totalAmount - deductedAmount
    return remainingAmount.toFixed(3)
  }
  return undefined
}
